import useAuthentication from "../Hooks/useAuthentication";
import { useAppSelector } from "../Store";
import { useAuthStore } from "../Store/Slices/AuthSlice";
import { isEmptyObject } from "../Utils";
import AuthRoutes from "./AuthRoutes";
import ProtectedRoutes from "./ProtectedRoutes";

const RootNavigator = () => {
  const { isUserLoggedIn } = useAuthentication();
  const { userConfig } = useAppSelector(useAuthStore);
  const permissionsData: any = userConfig?.payload?.allowed_permissions ?? null;

  if (
    isUserLoggedIn &&
    window.localStorage.getItem("expiry_time") &&
    userConfig?.payload &&
    isEmptyObject(permissionsData)
  )
    return null;
  return (
    <>
      {
        isUserLoggedIn ? ( <ProtectedRoutes />) : ( <AuthRoutes />)
      }
    </>
  );
};

export default RootNavigator;
